import type { DashboardWidgetConfiguration } from './widget-definition';
import { period } from './query-period';

export const salesTaxRateWidget: DashboardWidgetConfiguration = {
  widgetId: "sales.tax-rate",
  name: "Effective tax rate",
  description: "A percentage card with bounded dashboard time choices.",
  apps: [
    "home",
    "sales",
    "crm",
    "finance",
    "invoicing",
    "point-of-sale",
    "subscriptions",
  ],
  template: "percentage",
  query: {
    kind: "single",
    query: {
      version: 1,
      source: "sales.analysis",
      ...period(30),
      select: [
        {
          type: "formula",
          as: "tax_rate",
          data_type: "percentage",
          expression: {
            type: "binary",
            operator: "multiply",
            left: {
              type: "binary",
              operator: "safe_divide",
              left: {
                type: "aggregate",
                function: "sum",
                field: "tax_amount",
              },
              right: {
                type: "aggregate",
                function: "sum",
                field: "untaxed_amount",
              },
            },
            right: {
              type: "literal",
              value: 100,
            },
          },
        },
      ],
    },
  },
  inputs: {
    title: "Sales",
    caption: "Effective tax rate",
    presentation: "bar",
    color: "#066fd1",
  },
  dummyData: {
    value: "18.4%",
    change: "+2.1%",
  },
  limits: {
    minWidth: 3,
    maxWidth: 6,
    minHeight: 2,
    maxHeight: 4,
    defaultWidth: 4,
    defaultHeight: 2,
  },
};
